import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1959_237218)">
        <rect width={36} height={24} fill="white" />
        <rect
          x={0.75}
          y={0.75}
          width={34.5}
          height={22.5}
          stroke="#D9DDE3"
          strokeWidth={1.5}
        />
        <path d="M0 4H36V8H0V4Z" fill="#D9DDE3" />
        <path
          d="M4 16.5C4 15.9477 4.44772 15.5 5 15.5H18C18.5523 15.5 19 15.9477 19 16.5V18.5C19 19.0523 18.5523 19.5 18 19.5H5C4.44772 19.5 4 19.0523 4 18.5V16.5Z"
          fill="#D9DDE3"
        />
        <path
          d="M27.0293 18.5H26.5684V16.6621C26.5684 16.6009 26.569 16.5397 26.5703 16.4785C26.5716 16.4173 26.5729 16.3574 26.5742 16.2988C26.5768 16.2402 26.5801 16.1842 26.584 16.1309C26.5566 16.1608 26.5228 16.1934 26.4824 16.2285C26.4434 16.2637 26.4017 16.3001 26.3574 16.3379L26.0293 16.5996L25.7988 16.3086L26.6465 15.6445H27.0293V18.5Z"
          fill="currentcolor"
        />
        <path
          d="M29.9423 18.5H28.0087V18.1543L28.749 17.4043C28.8922 17.2585 29.0101 17.1328 29.1025 17.0273C29.1949 16.9206 29.2633 16.8197 29.3076 16.7246C29.3532 16.6296 29.3759 16.526 29.3759 16.4141C29.3759 16.276 29.3362 16.1719 29.2568 16.1016C29.1774 16.0299 29.0726 15.9941 28.9423 15.9941C28.8186 15.9941 28.7041 16.0189 28.5986 16.0684C28.4944 16.1165 28.3864 16.1855 28.2744 16.2754L28.0224 15.9727C28.1018 15.9049 28.1865 15.8431 28.2763 15.7871C28.3675 15.7311 28.469 15.6868 28.581 15.6543C28.693 15.6204 28.8206 15.6035 28.9638 15.6035C29.1448 15.6035 29.3011 15.6361 29.4326 15.7012C29.5641 15.765 29.665 15.8542 29.7353 15.9688C29.8069 16.0833 29.8427 16.2168 29.8427 16.3691C29.8427 16.5228 29.8121 16.6647 29.7509 16.7949C29.6897 16.9251 29.6025 17.054 29.4892 17.1816C29.3759 17.3079 29.2412 17.4453 29.0849 17.5938L28.5908 18.0762V18.0977H29.9423V18.5Z"
          fill="currentcolor"
        />
        <path
          d="M32.162 16.2969C32.162 16.4258 32.136 16.5378 32.0839 16.6328C32.0318 16.7279 31.9602 16.806 31.8691 16.8672C31.7792 16.9271 31.6751 16.9701 31.5566 16.9961V17.0098C31.7844 17.0384 31.9563 17.11 32.0722 17.2246C32.1894 17.3392 32.248 17.4909 32.248 17.6797C32.248 17.8451 32.2083 17.9928 32.1288 18.123C32.0494 18.252 31.9277 18.3535 31.7636 18.4277C31.5995 18.502 31.3886 18.5391 31.1308 18.5391C30.9758 18.5391 30.832 18.5267 30.6991 18.502C30.5676 18.4772 30.4426 18.4375 30.3241 18.3828V17.9746C30.4452 18.0345 30.5741 18.0807 30.7109 18.1133C30.8476 18.1458 30.9771 18.1621 31.0995 18.1621C31.3378 18.1621 31.5077 18.1178 31.6093 18.0293C31.7109 17.9395 31.7616 17.8158 31.7616 17.6582C31.7616 17.5566 31.7349 17.4733 31.6816 17.4082C31.6295 17.3431 31.5481 17.2943 31.4374 17.2617C31.328 17.2292 31.1868 17.2129 31.0136 17.2129H30.7616V16.8438H31.0155C31.1809 16.8438 31.3137 16.8242 31.414 16.7852C31.5142 16.7448 31.5865 16.6895 31.6308 16.6191C31.6764 16.5488 31.6991 16.4668 31.6991 16.373C31.6991 16.2507 31.6594 16.1556 31.58 16.0879C31.5006 16.0189 31.3827 15.9844 31.2265 15.9844C31.1301 15.9844 31.0422 15.9954 30.9628 16.0176C30.8847 16.0397 30.8124 16.0677 30.746 16.1016C30.6796 16.1354 30.6165 16.1719 30.5566 16.2109L30.3359 15.8926C30.4439 15.8118 30.5728 15.7435 30.7226 15.6875C30.8723 15.6315 31.0468 15.6035 31.246 15.6035C31.539 15.6035 31.7649 15.6667 31.9237 15.793C32.0826 15.918 32.162 16.0859 32.162 16.2969Z"
          fill="currentcolor"
        />
        <circle cx={29} cy={17} r={5.25} stroke="#FF0000" strokeWidth={1.5} />
      </g>
      <defs>
        <clipPath id="clip0_1959_237218">
          <rect width={36} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-cvv" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
